import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {SessionService} from '../services/session.service';

@Injectable({
  providedIn: 'root',
})
export class AdminAuthGuard  {
  constructor(
    private session: SessionService,
  ) {
  }


  canActivate(): boolean {
    if (this.session.isUserAdmin()) {
      return true;
    }

    this.session.logOut();
  }

}
